import { Component, OnInit } from '@angular/core';
import { ApiService, QueryParam } from 'src/app/services/api.services';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { AppNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { CardsComponent } from '../../../components/cards/cards.component';
import { MatList, MatListItem } from '@angular/material/list';
import {
	LearningDocItem,
	LearningFileType,
	LearningSection,
	STANDARD_LEARNING_SECTIONS,
	learningSectionsForCompanyType,
} from '../learning-content';

@Component({
	selector: 'app-learning-main-tab',
	templateUrl: './learning-main-tab.component.html',
	styleUrls: ['./learning-main-tab.component.scss'],
	imports: [AppNavigationHeaderComponent, CardsComponent, MatList, MatListItem],
})
export class LearningMainTabComponent implements OnInit {
	/** Default to Standard so non-care users always see working links even before profile resolves. */
	sections: LearningSection[] = STANDARD_LEARNING_SECTIONS;
	companyType?: 'advanced' | 'care' | string;

	constructor(
		private readonly apiService: ApiService,
		private readonly profileService: UserProfileService,
		public readonly loadingService: LoadingIndicatorService
	) {}

	async ngOnInit(): Promise<void> {
		try {
			const profile = await this.profileService.getUserProfile();
			this.companyType = profile?.activeRoleDetails?.company?.companyType;
			this.sections = learningSectionsForCompanyType(this.companyType);
		} catch {
			// Keep Standard catalog if profile lookup fails (same docs as pre-ITE-4840 non-care UX).
			this.sections = STANDARD_LEARNING_SECTIONS;
		}
	}

	async openLearningDoc(item: LearningDocItem): Promise<void> {
		const queryParameters: QueryParam[] = [
			{ param: 'fileName', value: item.fileName },
			{ param: 'fileType', value: item.fileType },
		];
		await this.downloadByType(item.fileType, queryParameters);
	}

	private async downloadByType(
		fileType: LearningFileType,
		queryParameters: QueryParam[]
	): Promise<void> {
		if (fileType === 'mp4') {
			await this.apiService.getLearningVideo(queryParameters);
		} else if (fileType === 'jpg') {
			await this.apiService.getLearningImage(queryParameters);
		} else {
			await this.apiService.getLearningManual(queryParameters);
		}
	}
}
